import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import { CdnIcon } from '@shared/ui';
const IconTitle = ({ content, mainIcon, contentRight, className }) => {
    const { IconTitle: theme } = useTheme('Shared');
    return (React.createElement("div", { className: cn(theme.root, className) },
        React.createElement("div", { className: theme.iconWrapper }, typeof mainIcon === 'string' ? React.createElement(CdnIcon, { icon: mainIcon, className: theme.cdnIcon }) : mainIcon),
        React.createElement("div", { className: theme.content }, typeof content === 'string' ? React.createElement("span", { className: theme.title }, content) : content),
        contentRight && React.createElement("div", { className: theme.contentRight }, contentRight)));
};
export default IconTitle;
